import React from 'react';
import '../css/navBar.css';
import '../css/registro.css';

export const ContainerAdminN = ({ id, mainContent, className }) => {


    return (
        <>
            <div id={id} className={'container bg-white rounded-4 containerRegistro containerAdmin '
                + className} >
                <div id={id + "Scroll"} className='h-100 scrollArea pt-sm-5 py-4 px-3 px-sm-2 '>
                    {mainContent}
                </div>
            </div>
        </>
    );
} 